import { Avatar, Empty, Tooltip } from 'antd'
import Pagination from 'components/Pagination'
import FolderTick from 'components/icons/FolderTick'
import PlacementNoData from 'components/icons/PlacementNoData'
import { EmptyWrapper } from 'modules/Users/Style/style'
import React, { useEffect, useState } from 'react'
import { StyledTableSqare } from '../../../../components/TableStyles/TableStylesSqare/TableStylesSqare'
import PlacementHistoryWithResume from '../../../../components/UIComponents/PlacementHistoryWithResume'
import {
  FolderTableName,
  FolderTableNameFlex,
  ImageAvatar,
  LetterBold,
  TableEllipse,
} from '../../style'
const TableWoleData = ({
  tableData,
  totalPages,
  handlePageChange,
  pageSize,
  getStudentPlacedList,
  tableloader,
  handleSorting,
  getPreviewData,
  getPlacementHistoryList,
  getJobRolePreview,
  jobCategoryList,
  selectedStudents,
  setSelectedStudents,
  isAllSelect,
  setIsAllSelect,
  setEnabled
}) => {
  const [isOpenHistory, setIsOpenHistory] = useState(false)
  const [studentId, setStudentId] = useState(null);
  const [selectedJobCategory,setSelectedJobCategory] = useState(null);

  const capitalizeFirstLetters = str => {
    return str
      ?.toLowerCase()
      ?.split(' ')
      ?.map(word => word.charAt(0).toUpperCase() + word.slice(1))
      ?.join(' ')
  }

  const handleNameClick = async (data, key) => {
    setSelectedJobCategory(key)
    setStudentId(data?.id)
    setIsOpenHistory(true)
  }
  const rowSelection = {
    selectedRowKeys: selectedStudents || [],
    onChange: (selectedRowKeys) => {
      setEnabled(true)
      setSelectedStudents(isAllSelect === true ? [] : selectedRowKeys);  
      setIsAllSelect(false);
    },
    getCheckboxProps: (record) => ({
      roles: record.roles,
      // optionally, add disabled: record.isDisable if needed
    }),
  };

  useEffect(() => {
    if (isAllSelect && tableData?.length) {
      const allRowKeys = tableData.map(record => record.id);
      setSelectedStudents(allRowKeys);
    }
  }, [isAllSelect, tableData]);
  


  const dynamicColumns =
    Array?.isArray(jobCategoryList) &&
    jobCategoryList?.map((key, index) => {
      return {
        title: key,
        dataIndex: key,
        sorter: true,
        key: key,
        align: 'center',
        width: 210,
        sortDirections: ['ascend', 'descend'],
        render: (text, record) => {
          const metrics = record?.jobrolesmetrics
            ? record?.jobrolesmetrics[key]
            : null

          return (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'center',
              }}
            >
              <div>
                <LetterBold onClick={() => handleNameClick(record, key)}>
                  {metrics?.applied ?? 0}
                </LetterBold>{' '}
                Applied /
                <LetterBold onClick={() => handleNameClick(record, key)}>
                  {metrics?.eligible ?? 0}
                </LetterBold>{' '}
                Eligible
              </div>
              {metrics?.placed > 0 && <FolderTick />}
            </div>
          )
        },
      }
    })

  const columns = [
    {
      title: 'Name',
      dataIndex: 'tittle',
      key: 'firstName',
      align: 'left',
      width: 250,
      sorter: true,
      fixed: 'left',
      sortDirections: ['ascend', 'descend'],
      render: (text, data) => (
        <FolderTableNameFlex>
          {data?.profileUrl ? (
            <ImageAvatar
              src={data?.profileUrl}
              width={'35px'}
              height={'35px'}
            />
          ) : (
            <Avatar>{data?.firstname?.charAt(0).toUpperCase()}</Avatar>
          )}
          <div>
            <FolderTableName
              fontsize={'15px'}
              color="#3249D7"
              onClick={() => handleNameClick(data)}
            >
              {capitalizeFirstLetters(data.firstname)}{' '}
              {capitalizeFirstLetters(data.lastname)}
            </FolderTableName>
            <FolderTableName fontsize={'15px'} color="#D8D8D8">
              {data.unirollno}
            </FolderTableName>
          </div>
        </FolderTableNameFlex>
      ),
    },
    {
      title: 'Contact Details',
      dataIndex: 'contact_details',
      key: 'Contact Details',
      align: 'left',
      width: 210,
      render: (text, data) => {
        return (
          <div>
            <div>{data.phonenumber}</div>
            <Tooltip title={`${data.primaryemail}`}>
              <TableEllipse>{data.primaryemail}</TableEllipse>
            </Tooltip>
          </div>
        )
      },
    },
    {
      title: 'Degree & Department',
      dataIndex: 'Degree_Department',
      sorter: true,
      key: 'degree',
      align: 'left',
      width: 210,
      sortDirections: ['ascend', 'descend'],
      render: (text, data) => (
        <div>
          <Tooltip title={`${data.degree} ${data.department}`} arrow>
            <TableEllipse>{data.degree}</TableEllipse>
            <TableEllipse>{data.department}</TableEllipse>
          </Tooltip>
        </div>
      ),
    },

    ...(dynamicColumns ?? []),
  ]

  return (
    <>
      <StyledTableSqare
          rowSelection={{
            type: 'checkbox',
            ...rowSelection,
          }}
          rowKey={record => record?.id}
        columns={columns}
        dataSource={tableData}
        pagination={false}
        onChange={handleSorting}
        loading={tableloader}
        scroll={{
          x: '1320',
        }}
        bordered
        locale={{
          emptyText: (
            <EmptyWrapper center>
              <Empty
                image={<PlacementNoData />}
                imageStyle={{ height: 180 }}
                description={
                  <b>
                    Oh No! <br />
                    Try Another Name
                  </b>
                }
              />
            </EmptyWrapper>
          ),
        }}
      />

      <Pagination
        totalPages={totalPages}
        pageSize={10}
        current={pageSize + 1}
        onChange={handlePageChange}
      />

      <PlacementHistoryWithResume
        studentId={studentId}
        isOpenHistory={isOpenHistory}
        setIsOpenHistory={setIsOpenHistory}
        getJobRolePreview={getJobRolePreview}
        getStudentPlacedList={getStudentPlacedList}
        getPlacementHistoryList={getPlacementHistoryList}
        getPreview={getPreviewData}
        selectedJobCategory={selectedJobCategory}
      />
    </>
  )
}

export default TableWoleData
